<template>
    <div class="main-container">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>
        <div style="text-align:left;">
            <b-form-checkbox v-model="show_historical">{{ $t('text.show_old_bookings') }}</b-form-checkbox>
        </div>

        <div class="input-group search-bar">
            <b-form-input v-model="search_text" :placeholder="$t('text.search')"></b-form-input>
            <button 
                v-if="search_text"
                type="button"
                class="btn clear-search-button"
                @click="search_text=''">
                ╳
            </button>
        </div>
        
        <table v-if="isSmallScreen">
            <tr>
                <th @click="setOrderBy('user__first_name')">{{ $t('text.name') }}</th>
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
                <th @click="setOrderBy('start_date')">{{ $t('text.dates') }}</th>
            </tr>
            <tr class="info-row" v-for="booking in bookings" :key="booking.id" @click="bookingClicked(booking)">
                <td>{{ booking.getFullName() }}</td>
                <td>{{ booking.getCabin() }}</td>
                <td>{{ booking.getStartDateString() }} <br> {{ booking.getEndDateString() }}</td>
            </tr>
        </table>

        <table v-if="!isSmallScreen">
            <tr>
                <th @click="setOrderBy('user__first_name')">{{ $t('text.name') }}</th>
                <!--<th @click="setOrderBy('user__email')">{{ $t('text.email') }}</th>-->
                <!--<th @click="setOrderBy('user__phone')">{{ $t('text.phone') }}</th>-->
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
                <th @click="setOrderBy('start_date')">{{ $t('text.dates') }}</th>
                <th @click="setOrderBy('created')">{{ $t('text.created') }}</th>
                <th @click="setOrderBy('notes')">{{ $t('text.message') }}</th>
                <th @click="setOrderBy('price')">{{ $t('text.price') }}</th>
                <th @click="setOrderBy('replied')">{{ $t('text.contacted') }}</th>
                <th @click="setOrderBy('payed')">{{ $t('text.payed') }}</th>
            </tr>
            <tr class="info-row" v-for="booking in bookings" :key="booking.id" @click="bookingClicked(booking)">
                <td>{{ booking.getFullName() }}</td>
                <!--<td>{{ booking.getEmail() }}</td>-->
                <!--<td>{{ booking.getPhone() }}</td>-->
                <td>{{ booking.getCabin() }}</td>
                <td>{{ booking.getStartDateString() }} <br> {{ booking.getEndDateString() }}</td>
                <td>{{ booking.getCreatedDateString() }}</td>
                <td>{{ booking.notes }}</td>
                <td>{{ booking.price }} {{ $t('text.sek') }}</td>
                <td>
                    <div>
                        <b-badge v-if="booking.replied" style="margin-right:8px;" variant="success" pill>
                            {{ $t('text.contacted') }}
                        </b-badge>
                        <b-badge v-if="!booking.replied" style="margin-right:8px;" variant="warning" pill>
                            {{ $t('text.not_contacted') }}
                        </b-badge>
                    </div>
                </td>
                <td>
                    <div>
                        <b-badge v-if="booking.payed" variant="success" pill>
                            {{ $t('text.payed') }}
                        </b-badge>
                        <b-badge v-if="!booking.payed" variant="warning" pill>
                            {{ $t('text.unpayed') }}
                        </b-badge>
                    </div>
                </td>
            </tr>
        </table>

        <b-pagination
            v-if="rows > 10"
            style="text-align:center;width:100%;margin-top:16px;"
            align="center"
            v-model="current_page"
            :total-rows="rows"
            :per-page="per_page"
            aria-controls="my-table"
        ></b-pagination>

    </div>
</template>

<script>
import BookingApiService from "../../services/booking_api_service";
import Booking from "../../models/booking";

export default {
    name: "BookingAdminComponent",
    data() {
        return {
            loading: false,
            bookings: [],
            show_historical: false,
            order_by: '-start_date',
            search_text: '',
            has_made_initial_call: false,
            per_page: 10,
            current_page: 1,
            rows: 0,
            windowWidth : window.innerWidth
        };
    },
    watch: {
        current_page: function() {
            if (this.has_made_initial_call) {
                this.fetchBookings(false);
            }
            if (this.$route.query.current_page != this.current_page && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/bookings", query: { show_historical: this.show_historical, current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },  
        show_historical: function() {
            if (this.has_made_initial_call) {
                this.current_page = 1;
                this.fetchBookings(true);
            }
            if (this.$route.query.show_historical != this.show_historical && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/bookings", query: { show_historical: this.show_historical, current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },  
        order_by: function() {
            if (this.has_made_initial_call) {
                this.current_page = 1;
                this.fetchBookings(false);
            }
            if (this.$route.query.order_by != this.order_by && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/bookings", query: { show_historical: this.show_historical, current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },  
        search_text: function() {
            if (this.has_made_initial_call) {
                this.current_page = 1;
                this.fetchBookings(false);
            }
            if (this.$route.query.search_text != this.search_text && this.isOnCorrectTab) {
                this.$router.push({path: "/admin/bookings", query: { show_historical: this.show_historical, current_page: this.current_page, order_by: this.order_by, search_text: this.search_text }});
            }
        },
    },
    computed: {
        isSmallScreen() {
            return this.windowWidth < 980;
        },
        isOnCorrectTab() {
            return this.$route.fullPath.includes('bookings')
        }
    },
    methods: {
        async fetchBookings(showLoader) {
            if (showLoader) {
                this.loading = true;
            }
            var params = "order_by=" + this.order_by + "&show_historical=" + (this.show_historical ? "true" : "false")
            if (this.search_text) {
                params += "&search=" + this.search_text.replaceAll("&", "").replaceAll("?", "")
            }
            try {
                const data = await BookingApiService.get(this.current_page, params);
                if (!this.has_made_initial_call) {
                    this.has_made_initial_call = true;
                }
                this.rows = data.data.count
                this.bookings = data.data.results.map(dict => {
                    return new Booking(dict);
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        setOrderBy(string) {
            if (string == this.order_by) {
                this.order_by = string.includes('-') ? string : '-'+string
            } else {
                this.order_by = string
            }
        },
        bookingClicked(booking) {
            this.$router.push('/booking/' + booking.id); 
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    created() {
        this.has_made_initial_call = false;
        if (this.$route.query.current_page && this.isOnCorrectTab) {
            this.current_page = this.$route.query.current_page;
        }

        if (this.$route.query.show_historical && this.isOnCorrectTab) {
            this.show_historical = this.$route.query.show_historical === "true";
        }

        if (this.$route.query.order_by && this.isOnCorrectTab) {
            this.order_by = this.$route.query.order_by;
        }

        if (this.$route.query.search_text && this.isOnCorrectTab) {
            this.search_text = this.$route.query.search_text;
        }
        this.fetchBookings(true);
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    }
};
</script>

<style scoped>
.main-container {
    overflow: visible;
    background-color: transparent;
    padding-bottom: 40px;
}

table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    border-radius: 8px;
    color: #495057;
    table-layout: fixed;
}

td, th {
    text-align: center;
    padding: 8px;
    height:80px;
    white-space: nowrap;
    overflow: hidden;
}

th:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

tr:nth-child(even) {
    background-color: #e7f2ff;
}

.info-row:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

.search-bar {
    margin-top: 40px;
    margin-bottom: 20px;
}

.clear-search-button {
    margin-left: -40px;
    z-index: 100;
    color: #000;    
}
</style>
